import React, { PureComponent } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, AutoComplete } from '@tencent/spaui';

import { HotKeyWorkData, FirstLevelHref } from './config';
import { logout } from '@/utils/logout';
import actions from '@/app/actions.js';
import { REACT_APP_ROOT_URL } from '@/constants/Constants';
import { reportUserBehaviorCgi } from '@/api/cgi/common';
class TopNav extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      keyword: '',
      showATC: false,
      showSearchIcon: true,
      hotKeywordPannelShow: false,
      showMoreNav: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchClear = this.handleSearchClear.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
    this.hotKeywordPannelShow = this.hotKeywordPannelShow.bind(this);
    this.handleMoreNavShow = this.handleMoreNavShow.bind(this);
    this.otherNavRender = this.otherNavRender.bind(this);
  }
  componentDidMount() {
    // 点击其他地方隐藏热门搜索 导航其他
    document.addEventListener('click', (e) => {
      this.setState({
        hotKeywordPannelShow: false,
        showMoreNav: false,
      });
    });
  }
  handleSearch(e, val, data, hotKey = false) {
    this.setState(
      {
        keyword: val,
      },
      (_) => {
        if (hotKey) {
          this.setState({ hotKeywordPannelShow: false });
          this.toSearch(val);
        }
      },
    );
  }
  handleSearchClear(e, val) {
    this.setState({
      keyword: '',
    });
  }
  handleKeyPress(e, val) {
    if (e.charCode == 13) {
      this.setState({ keyword: val[0], hotKeywordPannelShow: false });
      this.toSearch(val[0]);
    }
  }
  toSearch(keyword) {
    this.props.dispatch({
      type: actions.knowledgeTypes.search,
      response: keyword,
    });
    this.props.history.push(`/search/${keyword}`);
  }
  showAutoComponent(e, val) {
    this.setState({
      showATC: val,
      showSearchIcon: !val,
      keyword: '',
    });
    this.props.getSearchStatus(val);
    this.props.history.push('/');
  }
  hotKeywordPannelShow(e) {
    this.stopPropagation(e);
    this.setState({ hotKeywordPannelShow: true });
  }
  // 阻止冒泡
  stopPropagation(e) {
    e.nativeEvent.stopImmediatePropagation();
  }

  handleMoreNavShow(e) {
    const { showMoreNav } = this.state;
    this.stopPropagation(e);
    this.setState({
      showMoreNav: !showMoreNav,
    });
  }
  otherNavRender(data = [], value) {
    const { showMoreNav } = this.state;
    const { onChange } = this.props;
    const activeTop = data.filter((v) => v.catalog_id == value).length > 0;
    return (
      <li className={`${activeTop ? 'on' : ''}`}>
        <a className={showMoreNav ? 'has-subnav open' : 'has-subnav'}>
          <span onClick={this.handleMoreNavShow}>更多</span>
          <i className="navbar-arrow"></i>
        </a>
        <dl>
          {data.map((v, k) => {
            const active = value == v.catalog_id;
            return (
              <dd onClick={() => this.report(v.name)} key={v.catalog_id}>
                <Link className={`${active ? 'active' : ''}`} name={v.catalog_id} to={v.catalog_id ? `/list/article/${v.catalog_id}${!_.isEmpty(v.children) ? FirstLevelHref(v.children) : ''}` : v.path} onClick={(e) => onChange(e, v.catalog_id)}>
                  {v.name}
                </Link>
              </dd>
            );
          })}
        </dl>
      </li>
    );
  }
  report = (name) => {
    const param = {
      behavior: '点击',
      page1: '知识',
      page2: '知识库',
      page3: '导航栏',
      relation_name: `顶部导航栏-${name}`,
    };
    reportUserBehaviorCgi({ data: param });
  }
  render() {
    const { keyword = 'test', showATC, showSearchIcon, hotKeywordPannelShow, showMoreNav } = this.state;
    const { tabValue, account, onChange, NavData } = this.props;
    const TopNav = NavData.length ? [{ catalog_id: '', name: '首页', path: '/all' }, ...NavData] : [];
    const baseNav = [...TopNav].splice(0, 5); // 导航固定展示6个
    const otherNav = [...TopNav].splice(5, TopNav.length - 1);

    return (
      <div className="new-navbar help_navbar">
        <div className="navbar-body" style={{ display: 'flex' }}>
          <div className="navbar-hd">
            <div>
              <h1
                className="navbar-brand"
                onClick={(e) => {
                  onChange(e, undefined);
                  this.props.history.push('/all');
                }}
              >
                <span className="navbar-brand-logo" />
                {/* <span className="navbar-help-logo" /> */}
              </h1>
            </div>
          </div>
          <div id="NavTab" style={{ display: showATC ? 'none' : 'block' }}>
            <ul className="navbar-tabs">
              {TopNav.map((v, key) => {
                const active = v.catalog_id == tabValue;
                return (
                  <li className={`${active ? 'on' : ''}`} name={v.catalog_id} key={v.catalog_id} tab={v.name}>
                    <Link
                      name={v.catalog_id}
                      to={v.catalog_id ? `/list/article/${v.catalog_id}${!_.isEmpty(v.children) ? FirstLevelHref(v.children) : ''}` : v.path}
                      onClick={(e) => {
                        onChange(e, v.catalog_id);
                        this.setState({ showMoreNav: false });
                        this.stopPropagation(e);
                        this.report(v.name);
                      }}
                    >
                      <span>{v.name}</span>
                    </Link>
                  </li>
                );
              })}
              {/* {otherNav.length > 0 && this.otherNavRender(otherNav, tabValue)} */}
            </ul>
          </div>

          <div className="navbar-right">
            {account.agency_name || account.bm_name ? (
              <div id="NavUser">
                <MyComponent value={account} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(TopNav));

const MyComponent = (props = {}) => {
  const { value, className, isShowAS = true } = props;
  // const hasAccountCenterPermission = canUsePermission('62', Object.keys(value.privilege_list || []));
  const hasAccountCenterPermission = true;
  return (
    <div className={`${className} spaui-topnav-drop`}>
      <a className="nav-link">
        {value.agency_name || value.bm_name}
        <i className="icon-darr"></i>
      </a>
      <div className="spaui-topnav-menu my-card">
        <div className="feed-item">
          <div className="feed-img">
            <img src="//public.gdtimg.com/qzone/biz/gdt/image/ams.svg" alt="" />
          </div>
          <div className="feed-info">
            <div className="feed-title">{value.agency_name || value.bm_name}</div>
            <div className="feed-desc">
              {value.qq_number ? `QQ: ${value.qq_number}` : null}
              {value.qq_number && value.wechat_number ? '/' : null}
              {value.wechat_number ? `微信:${value.wechat_number}` : null}
            </div>
          </div>
        </div>
        <div className="my-card-footer">
          {hasAccountCenterPermission ? <Button href={`${REACT_APP_ROOT_URL}/agency/manage-account`}>账户中心</Button> : null}
          <i className="spaui-icon spaui-icon-divier"></i>

          {isShowAS ? <i className="spaui-icon spaui-icon-divier"></i> : null}
          <Button onClick={(_) => logout()}>退出</Button>
        </div>
      </div>
    </div>
  );
};

const LinkComponent = (props = {}) => {
  const { children, name, href = '', onClick, normalLink } = props;

  if (!normalLink) {
    return (
      <Link to={href} data-name={name} onClick={onClick} data-hottag={props['data-hottag']}>
        {children}
      </Link>
    );
  }
  return (
    <a data-name={name} href={href} target="_self" data-hottag={props['data-hottag']}>
      {children}
    </a>
  );
};
